import styled from 'styled-components';

const Row = styled.div`
  display: flex;
`;

export default Row;
